import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import authApi from '@/api/auth.api'

export const useUserStore = defineStore('user', () => {
  // State
  const user = ref(null)
  const token = ref(null)
  const error = ref(null)
  
  // Getters (computed)
  const isAuthenticated = computed(() => user.value !== null && token.value !== null
  )
  
  const username = computed(() => {
    if (!user.value) return ''
    return user.value.displayName || user.value.display_name || ''
  })
  
  const picture = computed(() => user.value?.profilePicture || user.value?.profile_picture || null)
  
  // Actions
  async function detect() {
    try {
      // Check if we have a token
      const storedToken = authApi.getStoredToken()
      if (!storedToken) {
        user.value = null
        token.value = null
        return null
      }
      
      // Fetch user profile from API
      token.value = storedToken
      const userData = await authApi.getMe()
      user.value = userData
      return userData
    } catch {
      // Token is invalid or expired
      user.value = null
      token.value = null
      authApi.logout()
      return null
    }
  }
  
  function login() {
    // Redirect to backend OAuth login endpoint
    authApi.login()
  }
  
  function handleCallback(jwtToken) {
    // Store JWT token from OAuth callback
    const success = authApi.handleCallback(jwtToken)
    if (success) {
      token.value = jwtToken
    }
    return success
  }
  
  async function logout() {
    authApi.logout()
    user.value = null
    token.value = null
  }
  
  function clearError() {
    error.value = null
  }
  
  return {
    // State
    user,
    token,
    error,
    // Getters
    isAuthenticated,
    username,
    picture,
    // Actions
    detect,
    login,
    handleCallback,
    logout,
    clearError
  }
}, {
  persist: {
    paths: ['token']  // Only persist token, user data will be fetched from API
  }
})
